import * as yup from 'yup'

export class VehicleCheckInTirePressureLabelDatesDto {
  tirePressureLabelOrderedDate?: string = undefined
  tirePressureLabelReceivedDate?: string = undefined
  vehicleCheckInIsTirePressureLabelPhotoMissing?: boolean = undefined
}

export const vehicleCheckInTirePressureLabelDatesValidationSchema = yup.object({
  tirePressureLabelOrderedDate: yup.date().typeError('Tire Pressure Label Ordered must be a date.').nullable(),
  tirePressureLabelReceivedDate: yup.date().typeError('Tire Pressure Label Received must be a date.').nullable()
})
